import Reveal, { SectionLabel } from "@/components/Reveal";
import { Quote } from "lucide-react";

const FounderStory = () => (
  <section id="founder" className="relative py-24 lg:py-36" data-testid="founder-section">
    <div className="max-w-7xl mx-auto px-5 sm:px-8 grid lg:grid-cols-12 gap-12 lg:gap-16 items-center">
      <div className="lg:col-span-5">
        <Reveal>
          <div className="relative chart-frame overflow-hidden border border-line gold-ring" data-testid="founder-portrait-frame">
            <img
              src="https://images.unsplash.com/photo-1679666600450-827f3486b4b3?crop=entropy&cs=srgb&fm=jpg&q=85&w=900"
              alt="Founder of Atlas at the charts"
              loading="lazy"
              className="w-full h-[420px] sm:h-[520px] object-cover opacity-90"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-ink via-ink/20 to-transparent" />
            <span className="absolute bottom-5 left-5 font-mono text-[10px] tracking-[0.3em] text-gold border border-gold/30 bg-ink/70 backdrop-blur px-3 py-1.5 rounded-sm uppercase">
              Founder · Atlas
            </span>
          </div>
        </Reveal>
      </div>

      <div className="lg:col-span-7">
        <Reveal>
          <SectionLabel>The Founder Story</SectionLabel>
          <h2 className="mt-5 font-display font-extrabold tracking-tight text-3xl sm:text-4xl lg:text-5xl text-slate-50 leading-tight" data-testid="founder-title">
            Built through sleepless nights,
            <span className="text-gold-gradient"> not shortcuts.</span>
          </h2>
        </Reveal>

        <Reveal delay={0.12}>
          <div className="mt-7 space-y-5 text-sm sm:text-base text-slate-400 leading-relaxed max-w-xl" data-testid="founder-story-copy">
            <p>
              Atlas began with one trader in Morocco, sitting alone through sleepless nights studying
              charts — blowing accounts, following other people's calls, and learning the hard way that
              signal groups sell dreams, not skill.
            </p>
            <p>
              So the approach changed: learn real analysis, build structure, journal everything. The
              indicator was coded for those late-night charts first — the zones, the confluence, the
              discipline. What started as one person's survival system has grown into a community of
              traders learning, analysing and progressing together — carrying the strength of the
              Atlas Lions with it.
            </p>
          </div>
        </Reveal>

        <Reveal delay={0.2}>
          <figure className="mt-9 border-l-2 border-gold pl-6 max-w-xl">
            <Quote size={18} className="text-gold/70 mb-3" />
            <blockquote className="font-display font-bold text-lg sm:text-xl text-slate-100 leading-snug" data-testid="founder-quote">
              "I'd rather teach you to read the market than have you depend on me forever.
              That's the whole point of Atlas."
            </blockquote>
            <figcaption className="mt-4 font-mono text-[11px] tracking-[0.25em] text-slate-500 uppercase">
              — Founder, Atlas
            </figcaption>
          </figure>
        </Reveal>
      </div>
    </div>
  </section>
);

export default FounderStory;
